import React, { Component } from 'react';
import SystemTranslationStatistic from './SystemTranslationStatistic';
import { browserHistory } from 'react-router';
import { observer } from 'mobx-react';
import SystemTranslationEmailTemplateStatisticService from '../services/SystemTranslationEmailTemplateStatisticService';

class SystemTranslationEmailTemplateStatisticContainer extends Component {
  systemTranslationEmailTemplateStatisticService = new SystemTranslationEmailTemplateStatisticService();

  componentDidMount() {
    this.systemTranslationEmailTemplateStatisticService.load();
  }

  render() {
    return (
      <SystemTranslationStatistic
        title="Email Templates"
        icon="mail"
        value={this.systemTranslationEmailTemplateStatisticService.summary}
        fetching={this.systemTranslationEmailTemplateStatisticService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/email-templates',
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

export default observer(SystemTranslationEmailTemplateStatisticContainer);
